let initState = {
    passport: {},
    accountStatement: {},
    registration: {},
    accountOwnership: {},
    anotherFile: [],
}

export function AddFiles(state = initState, action) {
    switch (action.type) {
        case 'ADD_FILE':
            return addFile(state, action.file)
            break
        case 'REMOVE_FILE':
            return removeFile(state, action.file)
            break
        default:
            return state
    }
}

function addFile(state, file) {
    if (file.dataType === 'anotherFile') {
        let arr = state.anotherFile.push(file)
        return Object.assign({}, state, arr)
    } else {
        return Object.assign(state, file)
    }
}

function removeFile(state, file) {
    if (!file.id) {
        return Object.assign(state, file)
    } else {
        return Object.assign({}, state, {
            anotherFile: state.anotherFile.filter((item, i) => {
                return i != file.id
            }),
        })
    }
}
